import { Adapter as i } from "../../../../adapter.js";
import { TicketHistoryPosModel as o } from "./ticketHistoryPos.model.js";
class d extends i {
  adapt(e) {
    var t, s;
    return new o({
      status: e.status,
      timestamp: new Date(e.timestamp * 1e3),
      posType: e.pos_type,
      externalId: e.external_id,
      additionalData: {
        requests: (t = e.additional_data) == null ? void 0 : t.requests,
        description: (s = e.additional_data) == null ? void 0 : s.description
      }
    });
  }
  serialize(e) {
  }
}
export {
  d as TicketHistoryPosAdapter
};
//# sourceMappingURL=ticketHistoryPos.adapter.js.map
